import React from "react";

import { screenerFeedback } from "../../api/client";
import styles from "./screenerPage.module.css";

// 结果下方一行：这次查找符合预期吗。「不对」可以补一句哪里不对。
// 反馈只为后续优化翻译，提交失败不打扰用户（静默）。父级用 key={queryId} 换新一句话时整体重置。
export function ScreenerFeedback({ queryId }) {
  const [step, setStep] = React.useState("ask");  // ask | note | done
  const [note, setNote] = React.useState("");

  function send(verdict, text = "") {
    setStep("done");
    screenerFeedback({ query_id: queryId, verdict, note: text }).catch(() => {});
  }

  if (step === "done") return <p className={styles.feedback} role="status">已记录，谢谢。</p>;
  if (step === "note") {
    return (
      <form className={styles.feedback} onSubmit={(event) => { event.preventDefault(); send("bad", note); }}>
        <input
          className={styles.feedbackInput}
          value={note}
          maxLength={200}
          placeholder="哪里不对？（可不填，例如：要的是 9 月，不是本月）"
          aria-label="哪里不对"
          onChange={(event) => setNote(event.target.value)}
        />
        <button type="submit" className={styles.retry}>提交</button>
      </form>
    );
  }
  return (
    <div className={styles.feedback}>
      <span>结果符合预期吗？</span>
      <button type="button" className={styles.tryChip} onClick={() => send("good")}>符合</button>
      <button type="button" className={styles.tryChip} onClick={() => setStep("note")}>不对</button>
    </div>
  );
}
